import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { HairServiceInput } from '../../gql/graphql';

interface AdvancedTabProps {
	serviceData: Partial<HairServiceInput>;
	updateServiceData: (updates: Partial<HairServiceInput>) => void;
}

function AdvancedTab({ serviceData, updateServiceData }: AdvancedTabProps) {
	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Advanced Settings
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Additional service information and custom fields
			</Typography>

			<Grid container spacing={3}>
				{/* MongoDB Reference ID */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="Service ID"
						name="_id"
						value={serviceData._id || 'Auto-generated after save'}
						disabled
						helperText="Unique identifier for this service"
					/>
				</Grid>

				{/* Future Custom Fields */}
				<Grid item xs={12}>
					<Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
						<Typography variant="body2" color="text.secondary">
							Additional custom fields can be added here in future updates based on your business needs.
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AdvancedTab;
